import { createBrowserRouter } from 'react-router-dom';
import { Suspense } from 'react';
import RedirectHandler from './RedirectHandler';
import {
  HomePage,
  // QuestionsPage,
  // MatchTherapistHome,
  ErrorBoundaryRoutes,
  QuestionsPage,
  BaseBotHandler,
  BaseUseCaseHandler,
} from './routeConfig';

const router = createBrowserRouter([
  {
    path: '/redirect',
    element: <RedirectHandler />,
    errorElement: (
      <Suspense fallback={null}>
        <ErrorBoundaryRoutes message="An error occurred while redirecting" />
      </Suspense>
    ),
  },
  {
    path: '/',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={null}>
            <HomePage /> {/* Regular home page */}
          </Suspense>
        ),
      },
      {
        path: 'questions',
        element: (
          <Suspense fallback={null}>
            <QuestionsPage />
          </Suspense>
        ),
      },
    ],
    errorElement: (
      <Suspense fallback={null}>
        <ErrorBoundaryRoutes message="Something went wrong" />
      </Suspense>
    ),
  },
  {
    path: '/:botName',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={null}>
            <BaseBotHandler />
          </Suspense>
        ),
      },

      {
        path: 'questions',
        element: (
          <Suspense fallback={null}>
            <QuestionsPage />
          </Suspense>
        ),
      },
      {
        path: ':useCase',
        children: [
          {
            index: true,
            element: (
              // <Suspense fallback={null}>
              <BaseUseCaseHandler />
              // </Suspense>
            ),
          },
          {
            path: 'questions',
            element: (
              // <Suspense fallback={null}>
              <QuestionsPage />
              // </Suspense>
            ),
          },
        ],
        errorElement: (
          // <Suspense fallback={null}>
          <ErrorBoundaryRoutes message="Something went wrong" />
          // </Suspense>
        ),
      },
    ],
    errorElement: (
      <Suspense fallback={null}>
        <ErrorBoundaryRoutes message="Something went wrong" />
      </Suspense>
    ),
  },
]);

export { router };
